<template>
  <v-card class="ma-3">
    <div class="d-flex align-end mb-3">
      <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
        <v-icon color="white"> mdi-bookmark </v-icon>
      </v-card>
      <span class="h4 ml-1 mb-n1">新建角色</span>
    </div>
    <v-form v-model="valid" ref="form" class="px-12">
      <v-text-field v-model="form.name" label="角色名称" required :rules="rules['name']"> </v-text-field>
      <v-select v-model="form.course" :items="courseList" item-text="name" item-value="_id" attach chips label="课程" multiple></v-select>
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click.stop="confirm">保存</v-btn>
      <v-btn color="gray" @click.stop="cancel">取消</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { listCourse } from '@/api/course'
import { addUserGroup, updateUserGroup, queryUserGroupById } from '@/api/admin/user_group'
export default {
  data: () => ({
    valid: false,
    courseList: [],
    form: {
      name: '',
      course: []
    },
    rules: {
      name: [(v) => !!v || '请填写角色名称'],
      course: [(v) => !!v || '请选择课程', (v) => v.length === 0 || '请选择课程']
    }
  }),
  created() {
    this.loadCourseList()
    if (this.$route.query._id) {
      this.findDataById(this.$route.query._id)
    }
  },
  methods: {
    async findDataById(_id) {
      queryUserGroupById(_id).then((res) => {
        this.form = Object.assign({}, res.data)
      })
    },
    loadCourseList() {
      listCourse({ perPage: 500 }).then((res) => {
        this.courseList = res.data.rows
      })
    },
    confirm() {
      this.$refs.form.validate()
      if (this.valid) {
        let handleFunc = this.form._id ? updateUserGroup : addUserGroup
        handleFunc(this.form).then((res) => {
          this.$store.dispatch('global/showSuccessMsg', '操作成功')
          this.$router.go(-1)
        })
      } else {
        this.$store.dispatch('global/showWarningMsg', '请填写完整的表单项')
      }
    },
    cancel() {
      this.$router.go(-1);
    }
  }
}
</script>
